export default {
    path: '/turntable',
    meta: {
        requiresAuth: true
    },
    components: {
        default: () => import(/* webpackChunkName: "Turntable" */ '../pages/Turntable.vue')
    }
}